import { FolderItemsPage } from '@app/components/FolderView/FolderItemsPage';

export function BusinessLibraryFolderItems() {
  return (
    <FolderItemsPage
      title="Business Library"
      linkPrefix="/business-library"
      queryKey="business-library"
    />
  );
}
